import styled from 'styled-components'
import {H6} from '@modifi/ui'
import SuccessBadge from '../../../../ui/success-badge'

export const Wrapper = styled.div``

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const DescriptionWrapper = styled(H6)`
  display: flex;
  justify-content: center;
`

export const PositionedSuccessBadge = styled(SuccessBadge)`
  position: absolute;
  left: 50%;
  margin-left: -20px;
  top: 50%;
  margin-top: -20px;
`
